<template>
  <div class="moneyDetail" style="background:#fff;">
    <van-nav-bar
      :title="$t('m.dj_span0')"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="level_my" style="position: relative;">
      <img src="../../assets/images/new/huyuan-top.png" alt="" />

      <div
        class="my_top"
        style="position: absolute;left:50%;top:35px; margin-left: -37.5px;"
      >
        <img src="../../assets/images/new/user-list.png" alt="" />
        <div class="info">
          <div>HI,{{ userInfo.realname }}</div>
        </div>
      </div>

      <div class="my_left">
        <div style=" position: absolute; right: 25px; top: 20px;">
          <!-- <img :src="vips[index11]" style="top:-20px; width: 50px;height: 50px;" /> -->
          <span
            style="top:-40px; width: 50px;height: 50px;display:block;color:#CDA569;font-size:28px;"
            ><span style="font-size:55px;font-weight:bold;">V</span
            >{{ index11 }}</span
          >
        </div>
        <div class="my_left-bot">
          <div>
            <span
              class="jifen"
              style="margin-left: 15px; font-weight: 600;font-size: 15px;"
            >
              {{ $t("m.dj_span5") }}： {{ parseInt(jifen) }}
            </span>
          </div>
          <!-- {{vipdengji.rate}}% -->
          <div style="margin-right: 15px;">{{ $t("m.dj_span1") }}</div>
        </div>
      </div>
    </div>

    <div style="padding:10px;" class="nameqq">
      <!-- <div style="line-height:50px;margin-bottom:30px;">VIP等级说明</div> -->
      <div
        class="level_info_title"
        style="background:#f6f5f6; color:#000; border-radius:8px 8px 0 0;overflow: hidden; font-size:14px;line-height:40px;display:flex;align-items:center;    justify-content: space-between;"
      >
        <span style="flex:1;text-align:center;font-weight:bold;">
          {{ $t("m.dj_span2") }}
        </span>
        <span style=" flex:1;text-align:center;font-weight:bold;">
          {{ $t("m.dj_span3") }}
        </span>
        <span style=" flex:1;text-align:center;font-weight:bold;">
          {{ $t("m.dj_span4") }}
        </span>
      </div>
      <div v-for="(item, index) in list" :key="index" class="level_info-box">
        <div
          class="level_info_title"
          :style="{ background: index % 2 == 1 ? '#f6f5f6' : '#fff' }"
          style=" border-bottom:1px solid #eee; font-size:14px;line-height:40px;display:flex;align-items:center;    justify-content: space-between;"
        >
          <span style="flex:1;text-align:center;font-weight:bold;"
            >VIP{{ item.level }}</span
          >
          <span
            style="color:#4b4e5f;flex:1;text-align:center;font-weight:bold;"
            >{{ item.integral }}</span
          >
          <span
            style="color:#a0935f;flex:1;text-align:center;font-weight:bold;"
            >{{ item.rate }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {level} from "@/components/model";
// import "@/assets/20fcd743/css/bootstrap.css";
import { getMyUserInfo } from "@api/user";
import request from "@utils/request";
export default {
  name: "",
  data() {
    return {
      userInfo: {},
      reportUrl: "https://m.soochows.com:443/home/ad/level",
      searchTableHeight: 0,
      searchTableWidth: 0,
      vips: [
        require("../../assets/images/new/big/VIP0.png"),
        require("../../assets/images/new/big/VIP1.png"),
        require("../../assets/images/new/big/VIP2.png"),
        require("../../assets/images/new/big/VIP3.png"),
        require("../../assets/images/new/big/VIP4.png"),
        require("../../assets/images/new/big/VIP5.png"),
        require("../../assets/images/new/big/VIP6.png"),
        require("../../assets/images/new/big/VIP7.png"),
        require("../../assets/images/new/big/VIP8.png"),
        require("../../assets/images/new/big/VIP9.png")
      ],
      jifen: 0,
      index11: 0,
      list: []
    };
  },
  mounted() {
    let _this = this;
    _this.searchTableHeight = window.innerHeight;
    _this.searchTableWidth = window.innerWidth;
    _this.requ();
    request
      .get("/user/level/list", {}, { login: false })
      .then(res => {
        console.log("登记列表");
        console.log(res.data.data);
        this.list = res.data.data;
      })
      .catch(err => {
        console.log(err);
      });
    let that = this;
    setTimeout(function() {
      request
        .post("/user/user/index", {}, { login: true })
        .then(res => {
          console.log("积分");
          console.log(res);
          that.jifen = res.data.data.integral;
        })
        .catch(err => {
          that.$dialog.error(err.response.data.msg);
        });
    }, 1000);
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    requ() {
      getMyUserInfo().then(res => {
        console.log(res.data, "oooooo");
        this.userInfo = res.data.data;

        let arr = [
          "普通会员",
          "VIP1",
          "VIP2",
          "VIP3",
          "VIP4",
          "VIP5",
          "VIP6",
          "VIP7",
          "VIP8",
          "VIP9"
        ];
        for (let i = 0; i < arr.length; i++) {
          const dic = arr[i];
          if (dic == this.userInfo.level) {
            this.index11 = i;
          }
        }
      });
    }
    // async onLoad() {
    // 	let res = await level();
    // 	if (res) {
    // 		this.html = res;
    // 	}
    // },
  },
  components: {}
};
</script>

<style scoped lang="less">
.level_info-box:last-child {
  margin-bottom: 80px;
}
.level_info_title span {
  border-top: 1px solid #f1f1f1;
  border-left: 1px solid #f1f1f1;
}

.level_info_title span:last-child {
  border-right: 1px solid #f1f1f1;
}

.level_info_title:last-child span {
  border-bottom: 1px solid #f1f1f1;
}

.moneyDetail /deep/ .van-nav-bar {
  box-shadow: 0 0 0 #fff;
  // background: url(../../images/zjmx_bgt.png) no-repeat;
  background: #fff;
  background-size: cover;
}
.moneyDetail /deep/ .van-nav-bar__title {
  color: #000;
}
.moneyDetail /deep/ .van-icon {
  color: #000;
}

.moneyDetail {
  // height: 100vh;
  // background-color: #f6f6f6;
  // background: url("../../images/bg233.png")  no-repeat,#f6f6f6;
  background-position: 0px -17px;
  background-size: 100%;
  .content {
    padding: 15px;
    .interest_card {
      display: flex;
      box-shadow: 0px 4px 10px 0px rgba(224, 224, 224, 0.5);
      border-radius: 15px;
      margin-top: 30px;
      background-color: #fff;
      div {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        span:nth-child(1) {
          padding: 30px 0 7px;
        }
        span:nth-child(2) {
          padding: 7px 0 30px;
        }
      }
    }
    .detail_card {
      margin-top: 21px;
      .card_item {
        display: flex;
        align-items: center;
        padding: 21px 14px 15px 9px;
        background-color: #fff;
        border-radius: 6px;
        margin-bottom: 15px;
        .c1 {
          flex: 1;
          text-align: center;
          img {
            width: 20px;
          }
        }
        .c2 {
          flex: 9;
          display: flex;
          flex-direction: column;
          .detail_text {
            font-size: 14px;
            // font-weight: 600;
            line-height: 20px;
            color: #333333;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            text-overflow: ellipsis;
          }
          .c_time {
            font-size: 13px;
            line-height: 18px;
            color: #999999;
          }
        }
        .c3 {
          flex: 2;
          font-size: 14px;
          font-weight: 600;
          color: #f62015;
        }
      }
    }
  }
}
.level_my {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: auto;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  padding-bottom: 80px;
}
.level_my img {
  width: 100%;
}

.my_left div:first-child {
  font-size: 17px;
}

.jifen {
  margin-right: 2.5px;
  font-weight: 500;
}

.my_left {
  font-size: 12px;
  font-family: PingFang;
  /* font-weight: 500; */
  color: #333333;
  position: absolute;
  top: 100px;
  height: 175px;
  width: 90%;
  left: 50%;
  margin-left: -45%;
  border-radius: 10px;
  text-align: center;
  margin-top: 50px;
  background-image: linear-gradient(to right, #cba85b, #f6ead0);
}
.my_left-bot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 10px;
  width: 100%;
  font-weight: 600;
}

.my_top {
  font-size: 15px;
  font-family: PingFang;
  /* font-weight: 500; */
  color: #ffffff;
}

.my_top .info {
  display: flex;
  flex-direction: column;
  color: #fff;
}

.my_top .info .vipdengji {
  border: 0.1px solid #333;
  text-align: center;
  font-size: 9px;
  padding: 3px;
  color: #333;
  display: flex;
}

.my_top > img {
  width: 75px;
  height: 75px;
  border-radius: 100%;
}

.index_top {
  background-color: #3e414f;
}

.jtr {
  width: 25px;
  height: 28px;
  left: 10px;
  position: absolute;
}

page {
  background: #171a29;
}

.level_info_title .rate {
  color: #a0935f;
}

.rate {
  /* background-image: -webkit-linear-gradient(left, #F4DFC6, #CDA768);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent; */
  font-size: 14px !important;
  font-family: DIN !important;
  font-weight: bold !important;
}

.not_yet {
  background-color: rgb(16, 19, 34);
}

.app {
  background-color: #fff;
}
</style>
